import Cleanser from "../assets/images/icons/Cleanser.png";
import Exfoliator from "../assets/images/icons/Exfoliator.png";
import EyeCream from "../assets/images/icons/EyeCream.png";
import FaceOil from "../assets/images/icons/FaceOil.png";
import MakeupRemover from "../assets/images/icons/MakeupRemover.png";
import Mask from "../assets/images/icons/Mask.png";
import Moisturizer from "../assets/images/icons/Moisturizer.png";
import Other from "../assets/images/icons/Other.png";
import Serum from "../assets/images/icons/Serum.png";
import Sunscreen from "../assets/images/icons/Sunscreen.png";
import Toner from "../assets/images/icons/Toner.png";
import Treatment from "../assets/images/icons/Treatment.png";

const icons: any = {
  cleanser: Cleanser,
  toner: Toner,
  exfoliator: Exfoliator,
  treatment: Treatment,
  moisturizer: Moisturizer,
  sunscreen: Sunscreen,
  serum: Serum,
  "eye cream": EyeCream,
  "makeup remover": MakeupRemover,
  "face oil": FaceOil,
  mask: Mask,
  "face mask": Mask,
  other: Other,
  other1: Other,
  other2: Other,
  other3: Other,
};

export default icons;
